import { m } from '~/paraglide/messages'
import { openBoostingPacks } from './boosting-packs'
import { showDialog } from './dialog'

/** Campaign currencies a purchase can run short of. `stamp` is the UI-layer
 *  name for the exchange-shop currency (backend: activity token). */
export type InsufficientCurrency = 'stamp' | 'coin' | 'gem'

const COPY: Record<
  InsufficientCurrency,
  { title: () => string; description: () => string; guide: () => string }
> = {
  stamp: {
    title: m.dialog_not_enough_stamps,
    description: m.dialog_not_enough_stamps_description,
    guide: m.dialog_not_enough_stamps_guide,
  },
  coin: {
    title: m.dialog_not_enough_balance_title,
    description: m.dialog_not_enough_balance_sunshine_description,
    guide: m.dialog_not_enough_coins_guide,
  },
  gem: {
    title: m.dialog_not_enough_balance_gem_title,
    description: m.dialog_not_enough_balance_gem_description,
    guide: m.dialog_not_enough_gem_guide,
  },
}

/**
 * Shared insufficient-balance dialog for every purchase surface (extra
 * boxes, exchange shop). Defaults to the Boosting Pack upsell (guide copy +
 * View Packs / Maybe Later); once every pack is purchased there is nothing
 * left to sell, so it falls back to the plain informational copy with OK.
 */
export const showInsufficientBalanceDialog = (options: {
  currency: InsufficientCurrency
  allPacksPurchased: boolean
}) => {
  const { title, description, guide } = COPY[options.currency]
  if (options.allPacksPurchased) {
    showDialog({
      title: title(),
      description: description(),
      primaryButtonText: m.ok(),
    })
    return
  }
  showDialog({
    title: title(),
    description: guide(),
    primaryButtonText: m.btn_view_packs(),
    secondaryButtonText: m.btn_maybe_later(),
    buttonLayout: 'stacked',
    // Must wait for the dialog to fully exit before the sheet opens —
    // overlapping the two modals corrupts their body pointer-events
    // snapshots and leaves the whole page uninteractable.
    primaryActionAfterExit: () => openBoostingPacks(),
  })
}
